import {ValidateEmailUserCommand} from '@perfectpost/perfect-post-common';
import {useMutation} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {authKeys} from '../keys';
import type {MutationUiOptions} from '../../../utils/mutationMeta';

/**
 * Marque l'e-mail de l'utilisateur comme validé, juste après sa première
 * connexion (`POST /me/validateemail`).
 *
 * Remplace les `send(new ValidateEmailUserCommand())` de `Confirm` et `Signin`,
 * lancés sans attendre ni traiter le résultat : les appelants relisent le profil
 * eux-mêmes juste après.
 */
export function useValidateEmailMutation(options: MutationUiOptions = {}) {
  return useMutation({
    ...options,
    mutationKey: [...authKeys.mutations(), 'validateEmail'],
    mutationFn: (): Promise<void> => sendOrThrow(new ValidateEmailUserCommand()),
  });
}
